package pl.nickers.match3

import kotlinproject.composeapp.generated.resources.Res
import kotlinx.serialization.json.Json

private val journeyJson = Json { ignoreUnknownKeys = true }

class JourneyCatalog(val entries: List<JourneyEntry>) {

    fun entryFor(id: Int): JourneyEntry? = entries.firstOrNull { it.id == id }

    companion object {
        /** Parses a catalog from a JSON string. Used in tests to avoid file I/O. */
        fun fromJson(jsonString: String): JourneyCatalog =
            JourneyCatalog(journeyJson.decodeFromString(jsonString))

        /** Loads and parses journey_index.json from the compose resource bundle. */
        suspend fun load(): JourneyCatalog {
            val bytes = Res.readBytes("files/journey_index.json")
            return fromJson(bytes.decodeToString())
        }
    }
}

/** Loads a single level config file referenced by a [JourneyEntry]. */
suspend fun JourneyCatalog.loadLevel(entry: JourneyEntry): LevelConfig {
    val bytes = Res.readBytes("files/${entry.file}")
    return journeyJson.decodeFromString(bytes.decodeToString())
}
